import createIcon from '../../createIcon';

/**
 * @component @name WatchOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNzA5NiA2LjY5NTMxQzE1LjQ2OTYgNi42OTUzMSAxNy43MDk2IDguOTM1MzEgMTcuNzA5NiAxMS42OTUzQzE3LjcwOTYgMTIuMzM1MyAxNy41Nzk2IDEyLjk0NTMgMTcuMzU5NiAxMy41MTUzTDE4Ljg1OTYgMTUuMDE1M0MxOS4zOTk2IDE0LjAyNTMgMTkuNzA5NiAxMi44OTUzIDE5LjcwOTYgMTEuNjk1M0MxOS43MDk2IDkuNDc1MzEgMTguNjc5NiA3LjUwNTMxIDE3LjA2OTYgNi4yMjUzMUwxNS43MDk2IDEuNjk1MzFIOS43MDk2MUw4Ljc0OTYxIDQuOTA1MzFMMTAuODg5NiA3LjA0NTMxQzExLjQ1OTYgNi44MjUzMSAxMi4wNjk2IDYuNjk1MzEgMTIuNzA5NiA2LjY5NTMxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTMuNTE5NjEgMi41MDUzMUwyLjA5OTYxIDMuOTE1MzFMNi41NTk2MSA4LjM3NTMxQzYuMDE5NjEgOS4zNjUzMSA1LjcwOTYxIDEwLjQ5NTMgNS43MDk2MSAxMS42OTUzQzUuNzA5NjEgMTMuOTE1MyA2LjczOTYxIDE1Ljg4NTMgOC4zNDk2MSAxNy4xNjUzTDkuNzA5NjEgMjEuNjk1M0gxNS43MDk2TDE2LjY2OTYgMTguNDg1M0wyMC40ODk2IDIyLjMwNTNMMjEuODk5NiAyMC44OTUzTDMuNTE5NjEgMi41MDUzMVpNMTIuNzA5NiAxNi42OTUzQzkuOTQ5NjEgMTYuNjk1MyA3LjcwOTYxIDE0LjQ1NTMgNy43MDk2MSAxMS42OTUzQzcuNzA5NjEgMTEuMDU1MyA3LjgzOTYxIDEwLjQ0NTMgOC4wNTk2MSA5Ljg3NTMxTDE0LjUyOTYgMTYuMzQ1M0MxMy45NTk2IDE2LjU2NTMgMTMuMzQ5NiAxNi42OTUzIDEyLjcwOTYgMTYuNjk1M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WatchOff = createIcon('WatchOff', [
  [
    'path',
    {
      d: 'M12.7096 6.69531C15.4696 6.69531 17.7096 8.93531 17.7096 11.6953C17.7096 12.3353 17.5796 12.9453 17.3596 13.5153L18.8596 15.0153C19.3996 14.0253 19.7096 12.8953 19.7096 11.6953C19.7096 9.47531 18.6796 7.50531 17.0696 6.22531L15.7096 1.69531H9.70961L8.74961 4.90531L10.8896 7.04531C11.4596 6.82531 12.0696 6.69531 12.7096 6.69531Z',
      key: 'etpbv7',
    },
  ],
  [
    'path',
    {
      d: 'M3.51961 2.50531L2.09961 3.91531L6.55961 8.37531C6.01961 9.36531 5.70961 10.4953 5.70961 11.6953C5.70961 13.9153 6.73961 15.8853 8.34961 17.1653L9.70961 21.6953H15.7096L16.6696 18.4853L20.4896 22.3053L21.8996 20.8953L3.51961 2.50531ZM12.7096 16.6953C9.94961 16.6953 7.70961 14.4553 7.70961 11.6953C7.70961 11.0553 7.83961 10.4453 8.05961 9.87531L14.5296 16.3453C13.9596 16.5653 13.3496 16.6953 12.7096 16.6953Z',
      key: 'a9rkzu',
    },
  ],
]);

export default WatchOff;
